import { useEffect, useRef } from "react";

export const AssistantMessages = ({ messages, loading }) => {
  const endRef = useRef(null);
  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [messages, loading]);

  return (
    <div className="flex-1 overflow-y-auto px-4 py-3 space-y-3 bg-[#F7F5F0]" data-testid="assistant-messages">
      {messages.map((m, i) => (
        <div key={`${i}-${m.role}`} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
          <div
            className={`max-w-[85%] rounded-2xl px-4 py-2.5 text-sm leading-relaxed whitespace-pre-wrap ${
              m.role === "user" ? "bg-[#0A2342] text-white rounded-br-md" : "bg-white text-[#1F2A44] border border-slate-200 rounded-bl-md"
            }`}
            data-testid={`assistant-msg-${m.role}`}
          >
            {m.text}
          </div>
        </div>
      ))}
      {loading && (
        <div className="flex justify-start" data-testid="assistant-typing">
          <div className="bg-white border border-slate-200 rounded-2xl rounded-bl-md px-4 py-3 flex gap-1">
            {[0, 1, 2].map((d) => (
              <span key={d} className="w-2 h-2 rounded-full bg-[#C8A96B] animate-bounce" style={{ animationDelay: `${d * 0.15}s` }} />
            ))}
          </div>
        </div>
      )}
      <div ref={endRef} />
    </div>
  );
};
